import { defineStore } from 'pinia'
import { authService } from '@/services/auth.service'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    token: localStorage.getItem('token') || null,
    isAuthenticated: false,
    permissions: []
  }),

  getters: {
    isLoggedIn: (state) => !!state.token && !!state.user,
    userPermissions: (state) => state.permissions,
    hasPermission: (state) => (permission) => {
      return state.permissions.some(p => p.slug === permission)
    },
    userName: (state) => state.user?.name || '',
    userEmail: (state) => state.user?.email || ''
  },

  actions: {
    async login(credentials) {
      try {
        const response = await authService.login(credentials)
        
        this.token = response.token
        this.user = response.user
        this.permissions = response.user.permissions || []
        this.isAuthenticated = true
        
        localStorage.setItem('token', this.token)
        localStorage.setItem('user', JSON.stringify(this.user))
        if (response.refresh_token) {
          localStorage.setItem('refresh_token', response.refresh_token)
        }
        
        return response
      } catch (error) {
        this.logout()
        throw error
      }
    },

    async register(data) {
      try {
        const response = await authService.register(data)

        this.token = response.token
        this.user = response.user
        this.permissions = response.user.permissions || []
        this.isAuthenticated = true

        localStorage.setItem('token', this.token)
        localStorage.setItem('user', JSON.stringify(this.user))
        if (response.refresh_token) {
          localStorage.setItem('refresh_token', response.refresh_token)
        }

        return response
      } catch (error) {
        this.logout()
        throw error
      }
    },

    async logout() {
      try {
        await authService.logout()
      } catch (error) {
        console.error('Logout API error:', error)
      } finally {
        this.token = null
        this.user = null
        this.permissions = []
        this.isAuthenticated = false
        
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('refresh_token')
      }
    },

    initializeAuth() {
      const token = localStorage.getItem('token')
      const user = localStorage.getItem('user')
      
      if (token && user) {
        try {
          this.token = token
          this.user = JSON.parse(user)
          this.permissions = this.user.permissions || []
          this.isAuthenticated = true
        } catch (error) {
          console.error('Failed to parse user data:', error)
          //this.logout()
        }
      }
    },

    async refreshUserData() {
      try {
        const response = await authService.getCurrentUser()
        this.user = response.user
        this.permissions = response.user.permissions || []
        localStorage.setItem('user', JSON.stringify(this.user))
      } catch (error) {
        console.error('Failed to refresh user data:', error)
        //this.logout()
      }
    }
  }
})
